
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Target } from "lucide-react";
import { BeginningStateExtractionDiagnostic } from "./BeginningStateExtractionDiagnostic";

export const BeginningStateExtractionDiagnosticButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="text-blue-600 border-blue-300 hover:bg-blue-50">
          <Target size={16} className="mr-2" />
          Diagnose State Beginning Reports
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-6xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>State Beginning Extraction Diagnostic</DialogTitle>
        </DialogHeader>
        <BeginningStateExtractionDiagnostic />
      </DialogContent>
    </Dialog>
  );
};
